export const theme = {
  colors: {
    background: "#141414",
    backgroundElevated: "#181818",
    backgroundMuted: "#1f1f1f",
    card: "#202020",
    glass: "rgba(20, 20, 20, 0.72)",
    glassStrong: "rgba(14, 14, 14, 0.92)",
    border: "rgba(255, 255, 255, 0.1)",
    text: "#f5f5f1",
    textMuted: "#b3b3b3",
    textSoft: "#8c8c8c",
    red: "#e50914",
    redHover: "#f6121d",
    white: "#ffffff",
    green: "#46d369",
    gold: "#f5c518",
  },
  fonts: {
    heading: "'Bebas Neue', sans-serif",
    body: "'Manrope', sans-serif",
  },
  shadows: {
    soft: "0 18px 40px rgba(0, 0, 0, 0.25)",
    strong: "0 32px 80px rgba(0, 0, 0, 0.45)",
  },
  radii: {
    sm: "12px",
    md: "18px",
    lg: "28px",
    pill: "999px",
  },
  breakpoints: {
    tablet: "768px",
    desktop: "1024px",
    wide: "1440px",
  },
};
